import React, { useEffect, useState } from 'react';
import { IoIosClose } from 'react-icons/io';
import { BASE_URL, USER_URL } from '../../../constant/api';
import axios from 'axios';
import ScaleLoader from 'react-spinners/ScaleLoader';

const ProductCard = ({ product, stockData, handleInputChange, isAddStock }) => {
    return (
        <div key={product.id} className="mb-10">
            <div className="border-2 my-2 rounded-lg flex flex-row items-center space-x-4 p-4 border-b border-gray-300 w-full">
                <div className="flex-shrink-0">
                    <img
                        src={
                            product.product_images?.[0]?.image
                                ? product.product_images[0].image.startsWith(BASE_URL)
                                    ? product.product_images[0].image
                                    : `${BASE_URL}${product.product_images[0].image}`
                                : "/images/default-product.png"
                        }
                        alt={product.name}
                        className="w-24 h-24 object-cover"
                    />
                </div>
                <div className="flex-1">
                    <h3 className="text-sm font-bold">{product.name}</h3>
                    <h3 className="text-sm font-bold">{product.id}</h3>
                    <p className="text-xs text-gray-600">
                        {product.description ? product.description.slice(0, 50) + (product.description.length > 50 ? '...' : '') : 'Demo description'}
                    </p>
                </div>
                <div className="flex items-center space-x-2">
                    <div
                        className={`w-3 h-3 rounded-full ${product.stock > 0 ? 'bg-green-500' : 'bg-red-500'}`}
                        title={product.stock > 0 ? 'In Stock' : 'Out of Stock'}
                    />
                </div>
            </div>
            <div className="flex flex-col space-y-2">
                <p className="text-brand-text-light text-sm">Quantity in Stock</p>
                <input
                    type="number"
                    placeholder={isAddStock ? 'Add Stock Quantity' : 'Update Stock Quantity'}
                    value={stockData[product.id]?.stock || (isAddStock ? 0 : product.stock)}
                    onChange={(e) => handleInputChange(product.id, 'stock', e.target.value)}
                    className="border-0 bg-brand-secondary-gray p-2 rounded-md"
                />
                <p className="text-brand-text-light text-sm">Stock Status</p>
                <select
                    value={stockData[product.id]?.stock_status || (product.stock > 0 ? 'true' : 'false')}
                    onChange={(e) => handleInputChange(product.id, 'stock_status', e.target.value)}
                    className="border-0 bg-brand-secondary-gray p-2 rounded-md"
                >
                    <option value="true">In Stock</option>
                    <option value="false">Out of Stock</option>
                </select>
            </div>
        </div>
    );
};

function StockUploadModal({ isOpen, setIsOpen, id }) {
    const [stockData, setStockData] = useState({});
    const [products, setProducts] = useState([]);
    const [successMessage, setSuccessMessage] = useState('');
    const [errorMessage, setErrorMessage] = useState('');
    const [updating, setUpdating] = useState(false);
    const [loading, setLoading] = useState(true); // new

    const fetchProducts = async () => {
        setLoading(true);
        try {
            const response = await USER_URL.get(`/products/seller/${id}/`);
            if (response.data.Status === '1') {
                setProducts(response.data.Data);
            }
        } catch (error) {
            console.error('Error fetching products:', error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchProducts();
    }, [id]);

    if (!isOpen) return null;

    const handleInputChange = (productId, field, value) => {
        setStockData((prevState) => ({
            ...prevState,
            [productId]: {
                ...prevState[productId],
                [field]: value,
            },
        }));
    };

    const handleUpdateStock = async (productId) => {
        const token = localStorage.getItem('token');
        setUpdating(true);
        try {
            const updatedStock = stockData[productId]?.stock;
            const updatedStatus =
                stockData[productId]?.stock_status !== undefined
                    ? stockData[productId]?.stock_status === 'true'
                    : products.find(p => p.id === productId).stock > 0;
            const response = await USER_URL.patch(
                `/products/seller/${productId}/`,
                {
                    stock: updatedStock,
                    stock_status: updatedStatus,
                },
                {
                    // headers: { 'Authorization': `Token ${token}` },
                }
            );

            if (response.data.Status === '1') {
                setSuccessMessage('Stock updated successfully!');
                fetchProducts();
                setTimeout(() => setSuccessMessage(''), 3000);
            } else {
                console.error(`Failed to update product ${productId}`);
            }
            setIsOpen(false);
        } catch (error) {
            console.error(`Error updating product ${productId}:`, error);
            setErrorMessage('Some products failed to update. Please try again.');
            setTimeout(() => setErrorMessage(''), 3000);
        } finally {
            setUpdating(false);
        }
    };

    return (
        <div
            className="fixed inset-0 z-50 bg-opacity-50 bg-gray-700 flex items-center justify-center"
            onClick={() => setIsOpen(false)}
        >
            <div
                className="bg-white p-10 rounded-lg w-11/12 md:w-1/2 lg:w-[500px]"
                onClick={(e) => e.stopPropagation()}
            >
                <div className="flex justify-between items-center">
                    <h2 className="text-xl font-bold">Update Stock</h2>
                    <IoIosClose className="cursor-pointer text-2xl" onClick={() => setIsOpen(false)} />
                </div>

                {successMessage && (
                    <div className="bg-green-100 text-green-800 p-3 rounded-lg my-4">
                        {successMessage}
                    </div>
                )}

                {errorMessage && (
                    <div className="bg-red-100 text-red-800 p-3 rounded-lg my-4">
                        {errorMessage}
                    </div>
                )}

                {loading ? (
                    <div className="flex justify-center items-center h-64">
                        <ScaleLoader color="#FFAE00" height={40} />
                    </div>
                ) : (
                    products.map((product) => (
                        <ProductCard
                            key={product.id}
                            product={product}
                            stockData={stockData}
                            handleInputChange={handleInputChange}
                            isAddStock={false}
                        />
                    ))
                )}

                <div className="mt-4">
                    <button
                        onClick={() => handleUpdateStock(id)}
                        disabled={updating}
                        className={`text-white rounded-lg p-2 w-full ${updating ? 'bg-gray-400 cursor-not-allowed' : 'bg-brand-primary'}`}
                    >
                        {updating ? 'Updating...' : 'Update Stock'}
                    </button>
                </div>
            </div>
        </div>
    );
}

export default StockUploadModal;
